export const TOKEN_FIELD_CORRESPONDING = {
  '{LissageTexteDateLimite}': 'dateEndChoice',
  '{TypeContrat}': 'typeLissageInfo',
  '{dateLissageChoiceValidated}': 'dateLissageChoiceValidated',
  '{LissageTexteDateFin}': 'dateReferencePeriod'
}